import { render, staticRenderFns } from "./planAdministration.vue?vue&type=template&id=057f77ab&scoped=true"
import script from "./planAdministration.vue?vue&type=script&lang=js"
export * from "./planAdministration.vue?vue&type=script&lang=js"
import style0 from "./planAdministration.vue?vue&type=style&index=0&id=057f77ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f77ab",
  null
  
)

export default component.exports